var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextFieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#a9a9a9;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.668 0.534)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.866,4H18.8a1.872,1.872,0,0,1,1.866,1.866v11.2A1.872,1.872,0,0,1,18.8,18.931H3.866A1.872,1.872,0,0,1,2,17.065V5.866A1.872,1.872,0,0,1,3.866,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.664,6l-9.332,6.532L2,6",
    transform: "translate(0 -0.134)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFieldIcon);
export default __webpack_public_path__ + "static/media/text-field-icon.4c8fb11dd7f30aed659ed709785948b0.svg";
export { ForwardRef as ReactComponent };